export enum AlertType {
  Allocations = 'Allocations',
  BillAutomation = 'Bill Automation',
  DataIngest = 'Data Ingest',
  DataInsights = 'Data Insights',
  EnergyStar = 'ENERGY STAR',
  IntervalData = 'Interval Data',
  Reporting = 'Reporting',
}
